/**
 * @opal/logos shim — brand logos as SVG components.
 *
 * Real brand icons already exist in @/shared/ui/components/icons/icons — this module
 * just re-exports them under the Svg* naming convention @opal/logos callers
 * expect. A few providers have no real icon anywhere in the codebase yet
 * (AWS/Bedrock, OpenRouter, Bifrost); those get the same generic
 * letter-badge fallback pattern as SvgWorkplaceLogo below until a real icon is
 * added to @/shared/ui/components/icons/icons.
 */
import React from "react";
import {
  OpenAIIcon,
  AnthropicIcon,
  OllamaIcon,
  AzureIcon,
  GeminiIcon,
  LiteLLMIcon,
  LMStudioIcon,
  MicrosoftIcon,
  MistralIcon,
  DeepseekIcon,
  QwenIcon,
  GoogleIcon,
  SlackIcon,
} from "@/shared/ui/components/icons/icons";

interface LogoProps {
  size?: number;
  className?: string;
  color?: string;
}

// Generic fallback logo
const WorkplaceLogo = ({ size = 32, className = "" }: LogoProps) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="32" height="32" rx="8" fill="#1a56db"/>
    <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold">O</text>
  </svg>
);

export const SvgWorkplaceLogo = WorkplaceLogo;
export const SvgWorkplaceLogoTyped = WorkplaceLogo;
export default WorkplaceLogo;

// Letter-badge fallback for providers with no real icon in
// @/shared/ui/components/icons/icons yet.
function makeFallbackLogo(letter: string, fill: string) {
  const FallbackLogo = ({ size = 32, className = "" }: LogoProps) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="32" height="32" rx="8" fill={fill} />
      <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold">{letter}</text>
    </svg>
  );
  return FallbackLogo;
}

export const SvgAws = makeFallbackLogo("A", "#FF9900");
export const SvgOpenrouter = makeFallbackLogo("O", "#6467F2");
export const SvgBifrost = makeFallbackLogo("B", "#0EA5E9");

export const SvgOpenai = OpenAIIcon;
export const SvgClaude = AnthropicIcon;
export const SvgOllama = OllamaIcon;
export const SvgAzure = AzureIcon;
export const SvgGemini = GeminiIcon;
export const SvgLitellm = LiteLLMIcon;
export const SvgLmStudio = LMStudioIcon;
export const SvgMicrosoft = MicrosoftIcon;
export const SvgMistral = MistralIcon;
export const SvgDeepseek = DeepseekIcon;
export const SvgQwen = QwenIcon;
export const SvgGoogle = GoogleIcon;
export const SvgSlack = SlackIcon;
